var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 177.856,
    viewBox: "0 0 144 177.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:none;stroke:#606060}.cls-1{stroke-width:2.835px}.cls-2{stroke-width:2.719px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Student",
    transform: "translate(.333 -.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    transform: "translate(21.539 32.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    d: "M463.963 198.506h-31.237c-2.154 0-2.782.637-2.8 2.8-.02 3.358.333 3.715 3.674 3.715h10.1v20.372c-1.025 0-2.025-.016-3.025 0a2.119 2.119 0 0 0-2.34 1.871 2.075 2.075 0 0 0 0 .448c-.016.726 0 1.455 0 2.341h-1.068l-20.661-.013c-1.546 0-1.875-.338-1.876-1.923v-94.126c0-1.671.5-2.174 2.184-2.174q44.193-.007 88.387 0",
    className: "cls-1",
    transform: "translate(-410.683 -85.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    d: "M460.074 145.822c0-1.773.02-3.546-.005-5.317a2.089 2.089 0 0 0-1.849-2.3 2.143 2.143 0 0 0-.5 0q-4.223-.02-8.447 0a2.132 2.132 0 0 0-2.373 2.395q-.03 5.212 0 10.426a2.173 2.173 0 0 0 2.47 2.423q4.119.019 8.238 0c1.694-.008 2.457-.792 2.47-2.513.006-1.709-.004-3.412-.004-5.114z",
    className: "cls-1",
    transform: "translate(-413.981 -86.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    d: "M460.073 166.694h.012c0-1.737.008-3.475 0-5.212a2.194 2.194 0 0 0-2.494-2.5q-4.118-.013-8.237 0a2.164 2.164 0 0 0-2.463 2.423q-.031 5.161 0 10.321c.009 1.719.779 2.482 2.489 2.491q4.118.023 8.237 0a2.154 2.154 0 0 0 2.451-2.423c.022-1.7.007-3.4.007-5.106z",
    className: "cls-1",
    transform: "translate(-413.98 -88.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    d: "M422.58 190.562c0 1.773-.013 3.546 0 5.319a2.074 2.074 0 0 0 2.32 2.319q4.224.027 8.448 0a2.111 2.111 0 0 0 2.393-2.366q.023-5.265 0-10.533a2.187 2.187 0 0 0-2.428-2.367q-4.172 0-8.346.024a2.155 2.155 0 0 0-2.391 1.888 2.12 2.12 0 0 0 0 .494c0 1.739.009 3.479.01 5.217z",
    className: "cls-1",
    transform: "translate(-411.487 -90.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    d: "M460.068 190.6h-.005c0-1.669.008-3.338 0-5-.013-1.857-.738-2.628-2.571-2.641q-4.115-.03-8.229.022a2.111 2.111 0 0 0-2.366 2.4q-.031 5.215 0 10.428a2.116 2.116 0 0 0 2.367 2.4q4.223.031 8.447 0a2.1 2.1 0 0 0 2.36-2.4c.023-1.738.008-3.478.008-5.215z",
    className: "cls-1",
    transform: "translate(-413.98 -90.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    d: "M435.754 225.534c0-1.773.02-3.546-.005-5.319a2.088 2.088 0 0 0-2.276-2.273q-4.328-.027-8.656 0a2.048 2.048 0 0 0-2.22 1.859 1.988 1.988 0 0 0 0 .358q-.036 5.371 0 10.741a2.063 2.063 0 0 0 2.275 2.27q4.275.031 8.552 0a2.1 2.1 0 0 0 2.332-1.851 2.137 2.137 0 0 0 0-.473c.01-1.766-.002-3.539-.002-5.312z",
    className: "cls-1",
    transform: "translate(-411.489 -94.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    d: "M422.587 166.576c0 1.705-.005 3.41 0 5.111.008 1.778.757 2.532 2.541 2.537 2.746.008 5.492 0 8.239 0a2.11 2.11 0 0 0 2.383-2.369q.023-5.214 0-10.429a2.155 2.155 0 0 0-2.433-2.437q-4.172-.019-8.346 0a2.124 2.124 0 0 0-2.384 2.372c-.012 1.739.001 3.476 0 5.215z",
    className: "cls-1",
    transform: "translate(-411.488 -88.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    d: "M422.589 145.8c0 1.772-.013 3.545 0 5.317a2.1 2.1 0 0 0 1.851 2.316 2.076 2.076 0 0 0 .381.007q4.328.046 8.654 0a2.1 2.1 0 0 0 2.271-2.292q.027-5.319 0-10.636a2.083 2.083 0 0 0-2.341-2.3q-4.224-.024-8.446 0a2.1 2.1 0 0 0-2.371 2.378c-.013 1.737 0 3.474 0 5.212z",
    className: "cls-1",
    transform: "translate(-411.487 -86.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    d: "M461.713 125.232H422.8c-.278 0-.6.09-.824-.022-.383-.2-.936-.488-.983-.808a1.3 1.3 0 0 1 .707-1.033c1.442-.5 2.93-.865 4.4-1.274q16.871-4.694 33.736-9.4a6.815 6.815 0 0 1 3.791 0q18.721 5.239 37.451 10.437c.234.066.538.064.689.213.314.305.787.718.751 1.038s-.587.628-.974.82a2.289 2.289 0 0 1-.927.026z",
    className: "cls-1",
    transform: "translate(-411.326 -83.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    d: "M460.59 131.03h-47.475a9.986 9.986 0 0 1-1.147-.025 1.927 1.927 0 0 1-1.732-1.795 1.905 1.905 0 0 1 1.483-2.1 4.982 4.982 0 0 1 1.137-.09q47.787-.005 95.577.015a3.834 3.834 0 0 1 1.86.463 1.712 1.712 0 0 1 .718 2.019 1.878 1.878 0 0 1-1.59 1.466 6.687 6.687 0 0 1-1.145.039z",
    className: "cls-1",
    transform: "translate(-410.221 -85.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    d: "M480.99 94.848c0 1.795.1 4.738 0 6.282-.064.918.367.053 0 .9-.656 1.492-1.961 3.026-2.692 4.487-.634 1.266-.543 2.682.9 2.692 1.808.013 1.694.158 3.5.145 1.551-.008 1.912-.628 1.193-2.043-.834-1.642-1.688-3.275-2.5-4.927a2.84 2.84 0 0 1-.329-1.176c-.032-2.086-.047-4.174.015-6.258a1.667 1.667 0 0 1 .628-1.141c1.278-.9 2.644-1.675 3.924-2.571a1.1 1.1 0 0 0-.217-2.1q-10.33-4.348-20.7-8.6a2.3 2.3 0 0 0-1.575-.005q-10.321 4.232-20.6 8.564c-.424.179-1 .661-1 1a1.868 1.868 0 0 0 .839 1.256q4.531 2.979 9.14 5.84a1.713 1.713 0 0 1 .954 1.746c-.066 1.353-.038 2.713 0 4.067.054 1.912 1.863 3.006 3.41 1.779a23.83 23.83 0 0 1 4.476-1.855c2.638-.665 3.578-.3 6.282 0a10.789 10.789 0 0 1 5.241 1.787 2.036 2.036 0 0 0 2.311.372 2.363 2.363 0 0 0 1.167-2.191c.013-1.425-.01-2.851.019-4.277.005-.32.059-.782.269-.932 1.007-.732 4.101-2.042 5.345-2.841z",
    className: "cls-1",
    transform: "translate(-413.432 -80.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    d: "M511 131.818c1.687 0 2.183.5 2.183 2.174v94.127c0 1.585-.329 1.923-1.876 1.923l-20.661.013h-1.068c0-.887.016-1.615 0-2.341a2.075 2.075 0 0 0 0-.448 2.119 2.119 0 0 0-2.341-1.871c-1-.016-2 0-3.025 0v-20.373H494.3c3.341 0 3.694-.356 3.674-3.715-.016-2.164-.644-2.8-2.8-2.8h-27.643",
    className: "cls-1",
    transform: "translate(-416.099 -85.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    d: "M471.539 150.641c.013 1.721.775 2.5 2.47 2.513q4.118.019 8.238 0a2.176 2.176 0 0 0 2.47-2.423q.03-5.214 0-10.426a2.132 2.132 0 0 0-2.375-2.393q-4.224-.022-8.447 0a2.088 2.088 0 0 0-2.346 2.3c-.025 1.772-.005 3.544-.005 5.317-.005 1.703-.014 3.406-.005 5.112z",
    className: "cls-1",
    transform: "translate(-416.51 -86.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    d: "M471.536 166.4c0 1.7-.015 3.407.007 5.106a2.154 2.154 0 0 0 2.451 2.423q4.119.017 8.237 0c1.71-.009 2.48-.772 2.489-2.491q.031-5.16 0-10.321a2.191 2.191 0 0 0 0-.6 2.165 2.165 0 0 0-2.458-1.824q-4.119-.013-8.237 0a2.194 2.194 0 0 0-2.494 2.5c-.008 1.737 0 3.475 0 5.212h.01z",
    className: "cls-1",
    transform: "translate(-416.509 -88.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    d: "M509.027 190.27c0-1.737.013-3.478.01-5.217a2.177 2.177 0 0 0 0-.5 2.154 2.154 0 0 0-2.391-1.887q-4.174-.024-8.346-.024a2.183 2.183 0 0 0-2.428 2.367q-.023 5.268 0 10.533a2.112 2.112 0 0 0 2.393 2.366q4.224.026 8.448 0a2.055 2.055 0 0 0 .52 0 2.076 2.076 0 0 0 1.8-2.323c.017-1.773 0-3.546 0-5.319z",
    className: "cls-1",
    transform: "translate(-419.004 -90.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    d: "M471.538 190.3c0 1.737-.015 3.477.008 5.215a2.1 2.1 0 0 0 2.36 2.4q4.224.031 8.447 0a2.146 2.146 0 0 0 .573 0 2.119 2.119 0 0 0 1.795-2.4q.027-5.214 0-10.428a2.111 2.111 0 0 0-2.366-2.4q-4.115-.053-8.229-.022c-1.833.013-2.559.784-2.571 2.641-.008 1.667 0 3.336 0 5.005h-.012z",
    className: "cls-1",
    transform: "translate(-416.51 -90.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    d: "M495.858 230.558a2.129 2.129 0 0 0 0 .472 2.105 2.105 0 0 0 2.332 1.851q4.277.031 8.552 0a2.066 2.066 0 0 0 2.275-2.27q.036-5.371 0-10.741a2.086 2.086 0 0 0 0-.359 2.047 2.047 0 0 0-2.22-1.858q-4.328-.032-8.656 0a2.088 2.088 0 0 0-2.276 2.273c-.025 1.773-.005 3.546-.005 5.319s-.011 3.543-.002 5.313z",
    className: "cls-1",
    transform: "translate(-419.003 -94.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    d: "M509.027 161.068a2.123 2.123 0 0 0-2.384-2.372q-4.174-.019-8.346 0a2.152 2.152 0 0 0-2.433 2.437q-.023 5.215 0 10.429a2.111 2.111 0 0 0 2.383 2.369c2.747 0 5.493.008 8.239 0 1.783-.005 2.533-.759 2.541-2.537.005-1.7 0-3.406 0-5.111-.002-1.738.011-3.476 0-5.215z",
    className: "cls-1",
    transform: "translate(-419.003 -88.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    d: "M509.025 145.5c0-1.738.013-3.476 0-5.212a2.12 2.12 0 0 0 0-.6 2.1 2.1 0 0 0-2.372-1.781q-4.222-.024-8.446 0a2.08 2.08 0 0 0-2.341 2.3q-.027 5.317 0 10.636a2.073 2.073 0 0 0 0 .373 2.1 2.1 0 0 0 2.272 1.919q4.327.044 8.654 0a2.075 2.075 0 0 0 .381-.008 2.1 2.1 0 0 0 1.851-2.315c.013-1.772 0-3.546 0-5.317z",
    className: "cls-1",
    transform: "translate(-419.004 -86.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    d: "M452.5 99.073s11.667-8.974 24.231.9",
    className: "cls-1",
    transform: "translate(-414.558 -81.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_65",
    d: "M0 0L49.072 0.005",
    className: "cls-1",
    transform: "translate(27.255 144.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_319",
    d: "M0 0H25.128V20.641H0z",
    className: "cls-2",
    transform: "translate(38.024 119.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_66",
    d: "M0 0L0 20.641",
    className: "cls-2",
    transform: "translate(50.589 119.459)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_341",
    fill: "none",
    d: "M0 0H144V177H0z",
    transform: "translate(-.333 .461)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.dcc9547f53982d62de968003075ba002.svg";
export { ForwardRef as ReactComponent };